'use client'

import { useEffect } from 'react'

import { ENCUENTRO_SCOPE_ATTRIBUTE, ENCUENTRO_SCOPE_VALUE } from '@/lib/design/encuentro-scope'

/**
 * Puts the Encuentro scope on `<html>` while a public page in Encuentro is
 * mounted, and restores what was there on unmount (the catalog's
 * `useHtmlAttribute`). Portalled menus and sheets mount in `body`, outside
 * the page's own scoped root, and need the `--en-*` tokens too.
 */
export function HtmlScope() {
  useEffect(() => {
    const html = document.documentElement
    const original = html.getAttribute(ENCUENTRO_SCOPE_ATTRIBUTE)
    html.setAttribute(ENCUENTRO_SCOPE_ATTRIBUTE, ENCUENTRO_SCOPE_VALUE)
    return () => {
      if (original === null) html.removeAttribute(ENCUENTRO_SCOPE_ATTRIBUTE)
      else html.setAttribute(ENCUENTRO_SCOPE_ATTRIBUTE, original)
    }
  }, [])
  return null
}
